import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { ButtonBase, Grid2 } from '@mui/material'
import Typography from '@mui/material/Typography'

import { MealNotesSelector, SelectedDateSelector } from '../../app/mealPlan/mealPlan.slice'
import { useAppSelector } from '../../app/store/hooks'
import Calendar from '../../components/mealPlanPage/Calendar/Calendar'
import ScheduledMeals from '../../components/mealPlanPage/scheduledMeals/ScheduledMeals'
import { filterMealsByDate } from '../../components/mealPlanPage/utils'
import useFetchMealPlan from '../../hooks/useFetchMealPlan'
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit'
import { UpIcon } from '../../iconRef/mealPLanIcons'
import { EventLogsEnum } from '../../utils/events'
import Loader from './Loader'
import styles from './MealPlan.module.css'

import useFetchMealNotes from '../../hooks/useFetchNotes'
import useFetchNutritionalTargets from '../../hooks/useFetchNutritionalTargets'

const MealPlan = () => {
  const history = useHistory();

  const onCompletedCustom = (mealPlanId: string | null) => {
    logRecipeEdit("VIEW_MEAL_PLAN", {
      meal_plan_id: mealPlanId,
    })
  }

  const selectedDate = useAppSelector(SelectedDateSelector);
  const [currentDate, setCurrentDate] = useState(selectedDate);
  const {nutrionalTargetDataLoading, refetchNutrionalTarget} = useFetchNutritionalTargets(selectedDate);
  const { mealPlanData, loading: mealPlanDataLoading, refetch, updateMealServingSize } = useFetchMealPlan(onCompletedCustom);
  const { notesDataLoading, refetchNotes } = useFetchMealNotes();
  const meals = mealPlanData?.Meal_Plan?.Meals;
  const notes = useAppSelector(MealNotesSelector);
  const selectedDateMeals = filterMealsByDate(selectedDate, meals);
  const { logRecipeEdit } = useLogRecipeEdit();

  const handleMealPlanAiClick = () => {
    logRecipeEdit(EventLogsEnum.GENERATE_MEAL_PLAN_OPENED);
    history.push('/meal-plan/ai');
  }

  
  return (
    <Grid2 className={styles.meal_plan_wrapper}>
      <Grid2 className={styles.meal_plan_container}>

        <Grid2 className={styles.calendar_container}>
          <Grid2 className={styles.header_section}>
            <Grid2 className={styles.header_title}>
              <Typography variant='body1Outfit'>Plan your meal</Typography>
              {/* <Grid2 className={styles.beta_image_container}><img alt="beta-tag" className={styles.meal_plan_beta_tag} src="/img/betaTag.png" /></Grid2> */}
            </Grid2>
            <ButtonBase className={styles.plan_with_up_button} onClick={handleMealPlanAiClick}><Typography variant='planWithUpText'>Plan with</Typography><UpIcon className={styles.up_icon} /></ButtonBase>
          </Grid2>
          <Calendar currentDate={currentDate} meals={mealPlanData?.Meal_Plan?.Meals} selectedDate={selectedDate}
            setCurrentDate={setCurrentDate} notes={notes} />
        </Grid2>
        <ScheduledMeals meals={selectedDateMeals} refetchMeals={refetch} selectedDate={selectedDate} updateMealServingSize={updateMealServingSize} refetchNotes={refetchNotes} refetchNutrionalTarget={refetchNutrionalTarget}/>
      </Grid2>
      <Loader loading={mealPlanDataLoading || notesDataLoading || nutrionalTargetDataLoading} />

    </Grid2>
  )
}

export default MealPlan
